

export default {
    getOriginalLayout(state) {
        // console.log('getters', state.grid)
        return state.grid;
    }
}